import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from './api.service';
import type { FamilyPlanView } from '../shared/types/family-plan-view.types';

/** Reads the Family Plan tab (CWS-1582): data access only. */
@Injectable({ providedIn: 'root' })
export class FamilyPlanViewService {
  constructor(private readonly api: ApiService) {}

  getForCustomer(customerId: string): Observable<FamilyPlanView> {
    return this.api
      .get<FamilyPlanView>(`order/family-plan/v2/customer/${customerId}`)
      .pipe(map(response => response.data ?? { in_family: false }));
  }
}
